import { useTheme } from '@mui/material';
import { Box } from '@mui/system';

import { StatusVariant } from '~enums';
import { getStatusBackgroundColor, getStatusForegroundColor } from '~enums/statusVariant';
import { Dimens } from '~themes';

interface StatusDotProps {
	innerSize?: string;
	outerSize?: string;
	variant?: StatusVariant;
}

const StatusDot = ({
	innerSize = Dimens.spacingSm,
	outerSize = Dimens.spacingLg,
	variant = StatusVariant.Success,
}: StatusDotProps) => {
	const { palette } = useTheme();
	const outerBackgroundColor = getStatusBackgroundColor(variant, palette);
	const innerBackgroundColor = getStatusForegroundColor(variant, palette);

	return (
		<Box
			sx={{
				height: outerSize,
				width: outerSize,
				minHeight: outerSize,
				minWidth: outerSize,
				borderRadius: Dimens.radiusFull,
				backgroundColor: outerBackgroundColor,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Box
				sx={{
					height: innerSize,
					width: innerSize,
					minHeight: innerSize,
					minWidth: innerSize,
					borderRadius: Dimens.radiusFull,
					backgroundColor: innerBackgroundColor,
				}}
			/>
		</Box>
	);
};

export default StatusDot;
